import wabaChatsTypes from "./wabaChatsTypes";
import { PENDING, SUCCESS, ERROR } from "../globalStatuses/globalStatuses";

const initialState = {
    conversations: [],
    conversationsStatus: '',
    conversationsTotal: 0,
    activeConversationId: null,
    messages: [],
    messagesStatus: '',
    hasMoreMessages: true,
    sendStatus: '',
}

const wabaChatsReducer = (state = initialState, action) => {
    switch (action.type) {
        case wabaChatsTypes.GET_CONVERSATIONS_PENDING:
            return { ...state, conversationsStatus: PENDING };
        case wabaChatsTypes.GET_CONVERSATIONS_SUCCESS:
            return {
                ...state,
                conversationsStatus: SUCCESS,
                conversations: action.payload.conversations,
                conversationsTotal: action.payload.total,
            };
        case wabaChatsTypes.GET_CONVERSATIONS_ERROR:
            return { ...state, conversationsStatus: ERROR };
        case wabaChatsTypes.GET_MESSAGES_PENDING:
            return { ...state, messagesStatus: PENDING, messages: [], hasMoreMessages: true };
        case wabaChatsTypes.GET_MESSAGES_SUCCESS:
            return {
                ...state,
                messagesStatus: SUCCESS,
                messages: [...action.payload].reverse(),
                hasMoreMessages: action.payload.length >= 30,
            };
        case wabaChatsTypes.GET_MESSAGES_ERROR:
            return { ...state, messagesStatus: ERROR };
        case wabaChatsTypes.LOAD_MORE_MESSAGES_SUCCESS: {
            const olderMessages = [...action.payload].reverse();
            return {
                ...state,
                messages: [...olderMessages, ...state.messages],
                hasMoreMessages: action.payload.length >= 30,
            };
        }
        case wabaChatsTypes.POLL_NEW_MESSAGES_SUCCESS: {
            const newMessages = [...action.payload].reverse();
            const existingIds = new Set(state.messages.map(m => m.id));
            const unique = newMessages.filter(m => !existingIds.has(m.id));
            if (unique.length === 0) return state;
            return { ...state, messages: [...state.messages, ...unique] };
        }
        case wabaChatsTypes.SEND_MESSAGE_OPTIMISTIC: {
            const exists = state.messages.some(m => m.id === action.payload.id);
            const messages = exists
                ? state.messages.map(m => m.id === action.payload.id ? action.payload : m)
                : [...state.messages, action.payload];
            return { ...state, messages, sendStatus: PENDING };
        }
        case wabaChatsTypes.SEND_MESSAGE_SUCCESS: {
            const updated = state.messages.map(m =>
                m.id === action.payload.tempId ? action.payload.message : m
            );
            return { ...state, messages: updated, sendStatus: SUCCESS };
        }
        case wabaChatsTypes.SEND_MESSAGE_ERROR: {
            const updated = state.messages.map(m =>
                m.id === action.payload ? { ...m, status: 'failed' } : m
            );
            return { ...state, messages: updated, sendStatus: ERROR };
        }
        case wabaChatsTypes.SET_ACTIVE_CONVERSATION:
            if (state.activeConversationId === action.payload) return state;
            return { ...state, activeConversationId: action.payload, messages: [], messagesStatus: '' };
        case wabaChatsTypes.MARK_READ_SUCCESS: {
            const updated = state.conversations.map(c =>
                c.id === action.payload ? { ...c, unread_count: 0 } : c
            );
            return { ...state, conversations: updated };
        }
        case wabaChatsTypes.DISMISS_MESSAGE_SUCCESS: {
            return { ...state, messages: state.messages.filter(m => m.id !== action.payload) };
        }
        case wabaChatsTypes.CLEAR_MESSAGES:
            return { ...state, messages: [], messagesStatus: '', hasMoreMessages: true };
        case wabaChatsTypes.CLEAR_ALL:
            return { ...initialState };
        default:
            return state;
    }
}
export default wabaChatsReducer
